import { Box, Typography } from '@mui/material';
import { DATAGRID_TABLE_CELL_WIDTH } from '../../../../utils/constants';

const displacementTablecColumns = (renderValueCell, renderDrillFluidCell, renderActions, displacmenet, renderTargetsEditAction, renderTrackAction) => [
  {
    field: 'row',
    headerName: 'Row#',
    headerAlign: 'center',
    align: 'center',
    width: 70
  },
  {
    field: 'flow_in',
    headerName: `Flow Rate (${displacmenet?.flow_in?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Flow
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
        Rate ({displacmenet?.flow_in?.label})
      </Typography>
      </Box>
    ),
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 100,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 100,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return parseFloat(value.toFixed(displacmenet?.from?.decimals));
    },
  },
  {
    field: 'fluid_id',
    headerName: 'Displacing Fluid',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 20,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderEditCell: renderDrillFluidCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'fluid_volume',
    headerName: `Displacing Volume (${displacmenet?.fluid_volume?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Displacing
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Volume ({displacmenet?.fluid_volume?.label})
      </Typography>
      </Box>
    ),
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 100,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 100,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return parseFloat(value.toFixed(displacmenet?.fluid_volume?.decimals));
    },
  },
  {
    field: 'pumps_output',
    headerName: `Total Pumps Output (${displacmenet?.pumps_output?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Total Pumps
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Output ({displacmenet?.pumps_output?.label})
      </Typography>
      </Box>
    ),
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 80,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 80,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return parseFloat(value.toFixed(displacmenet?.pumps_output?.decimals));
    },
  },
  {
    field: 'step_size',
    headerName: `Step Size (${displacmenet?.step_size?.label})`,
    renderHeader: () => (
      <Box>
      <Typography sx={{ fontSize: '1.2rem' }}>
      Step Size
      </Typography>
      <Typography sx={{ fontSize: '1.2rem' }}>
      ({displacmenet?.step_size?.label})
      </Typography>
      </Box>
    ),
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 80,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 80,
    renderEditCell: renderValueCell,
    editable: true,
    headerAlign: 'center',
    align: 'center',
    valueFormatter: (params) => {
      if (params.value === null || params.value === undefined || params.value === '') {
        return '';
      }
      const value = Number(params.value);
      if (isNaN(value)) {
        return params.value;
      }
      return parseFloat(value.toFixed(displacmenet?.step_size?.decimals));
    },
  },
  {
    field: 'target_data',
    headerName: 'Target',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH + 50,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH,
    renderCell: renderTargetsEditAction,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'track',
    headerName: 'Track',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 150,
    renderCell: renderTrackAction,
    headerAlign: 'center',
    align: 'center',
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 1,
    minWidth: DATAGRID_TABLE_CELL_WIDTH.MINWIDTH - 70,
    maxWidth: DATAGRID_TABLE_CELL_WIDTH.MAXWIDTH - 80,
    headerAlign: 'center',
    align: 'center',
    renderCell: renderActions,
  }
];

export { displacementTablecColumns };
